import React, { useRef, useEffect, useState } from 'react';

const KnowTrace = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);



  return (
    <section id="products" className="knowtrace" ref={sectionRef}>
      <div className="container">
        <div className={`section-content ${isVisible ? 'section-content--visible' : ''}`}>
          <div className="product-hero">
            <div className="product-intro">
              <div className="section-badge">
                <span className="badge-text">Flagship Product</span>
              </div>
              <h2 className="product-title">
                <span className="product-name">KnowTrace</span>
                <span className="product-separator"> — </span>
                <span className="product-subtitle">Knowledge Base Inference System</span>
              </h2>
              <p className="product-description">
                Transform scattered enterprise knowledge into <strong>instant, actionable insights</strong>. 
                KnowTrace is the AI-powered system that turns your data chaos into competitive advantage.
              </p>
              
              <div className="product-metrics">
                <div className="metric">
                  <div className="metric-value">&lt; 0.3s</div>
                  <div className="metric-label">Response Time</div>
                </div>
                <div className="metric">
                  <div className="metric-value">99.7%</div>
                  <div className="metric-label">Accuracy</div>
                </div>
                <div className="metric">
                  <div className="metric-value">24/7</div>
                  <div className="metric-label">Availability</div>
                </div>
              </div>
              
              <div className="product-cta">
                <a 
                  href="https://knowtrace.ai" 
                  className="cta-primary cta-primary--large"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <span>Experience KnowTrace</span>
                  <svg className="cta-arrow" viewBox="0 0 20 20">
                    <path d="M7 3l7 7-7 7" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
                <button className="cta-secondary cta-secondary--large">
                  <span>Schedule Demo</span>
                </button>
              </div>
            </div>
            
            <div className="product-visual">
              <div className="demo-container">
                <div className="demo-header">
                  <div className="demo-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <span className="demo-title">KnowTrace Dashboard</span>
                </div>
                <div className="demo-content">
                  <div className="chat-interface">
                    <div className="chat-message chat-message--user">
                      <div className="message-content">
                        What's our Q3 performance compared to industry benchmarks?
                      </div>
                    </div>
                    <div className="chat-message chat-message--ai">
                      <div className="ai-avatar">AI</div>
                      <div className="message-content">
                        <div className="typing-indicator">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        Based on 47 documents and 12 data sources, your Q3 revenue grew 23% vs industry average of 18%...
                      </div>
                    </div>
                  </div>
                  <div className="insights-panel">
                    <div className="insight-card">
                      <div className="insight-data">
                        <div className="insight-value">23%</div>
                        <div className="insight-label">Revenue Growth</div>
                      </div>
                    </div>
                    <div className="insight-card">
                      <div className="insight-data">
                        <div className="insight-value">+5%</div>
                        <div className="insight-label">vs Industry</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KnowTrace;
